import type { SubCase } from '@/lib/sub-cases/types';

// Shared PNR-group helpers for the allocation workspace. Reusable across both
// allocation scopes (a disruption event spanning N cases, and a single case) —
// see docs/ui/reusable-allocation-components.plan.md. Kept out of the component
// files so Fast Refresh stays component-only.

/** `urn:pnr:XYZ123:vendor:mock` → `XYZ123`. */
export function pnrLabel(pnrUrn: string): string {
  const m = /^urn:pnr:([^:]+)/.exec(pnrUrn);
  return m ? m[1]! : pnrUrn;
}

/** Rooms a group needs: ~2 pax per room, at least one. */
export function estimateRooms(subCase: SubCase): number {
  return Math.max(1, Math.ceil(subCase.passengers.length / 2));
}
